import { gql } from '@apollo/client';

export const FETCH_SUPPLIERS = gql`
  query GetSuppliers {
    findAllSupplier {
      approxAnualSpend
      availableAlternatives
      city
      country
      qualifiedAlternatives
      sourcingStatus
      state
      street
      supplierAddress
      supplierName
      supplierRecoveryTime
      timeToReplaceSupplier
      uuid
      zipCode
      bcpUpdatedAt
      bcpUploaded
      comment
    }
  }
`;

export const CREATE_SUPPLIER = gql`
  mutation CreateSupplier($data: CreateSupplierInput!) {
    createSupplier(data: $data) {
      supplierName
      street
      state
      city
      zipCode
      country
      approxAnualSpend
      supplierRecoveryTime
      timeToReplaceSupplier
      availableAlternatives
      qualifiedAlternatives
      uuid
      comment
    }
  }
`;

export const EDIT_SUPPLIER = gql`
  mutation EditSupplier($data: UpdateSupplierInput!) {
    updateSupplier(data: $data) {
      supplierName
      street
      state
      city
      zipCode
      country
      approxAnualSpend
      supplierRecoveryTime
      timeToReplaceSupplier
      availableAlternatives
      qualifiedAlternatives
      uuid
      comment
    }
  }
`;

export const DELETE_SUPPLIER = gql`
  mutation DeleteSupplier($uuid: ID!) {
    deleteSupplier(uuid: $uuid) {
      supplierName
    }
  }
`;

export const GET_SUPPLIER_MATERIALS = gql`
  query GetSupplierMaterials($uuid: ID!) {
    findAllMaterialsBySupplier(uuid: $uuid) {
      name
      uuid
    }
  }
`;

export const CREATE_SUPPLIER_MATERIAL = gql`
  mutation CreateMaterial($data: CreateMaterialInput!) {
    createMaterial(data: $data) {
      name
      uuid
    }
  }
`;

export const EDIT_SUPPLIER_MATERIAL = gql`
  mutation EditSupplierMaterial($data: UpdateMaterialInput!) {
    updateMaterial(data: $data) {
      name
      uuid
    }
  }
`;

export const DELETE_SUPPLIER_MATERIAL = gql`
  mutation DeleteSupplierMaterial($uuid: ID!) {
    deleteMaterial(uuid: $uuid) {
      name
    }
  }
`;
